;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('ColumnService', ColumnService)

  ColumnService.$inject = ['PreferencesService', 'AppAccessService']

  /**
   * Constructor
   */
  function ColumnService (PreferencesService, AppAccessService) {
    var self = this

    _.extend(self, {
      // Public Attributes
      rightsReached: false,
      // Public Methods
      getDefaultColumns: getDefaultColumns,
      getColumns: getColumns,
      buildColumns: buildColumns,
      init: init
    })

    var defaultColumns = {
      invoice: [
        { id: 'number', label: 'Numéro', visible: true, sortable: true },
        { id: 'reference', label: 'Référence client', visible: true, sortable: true },
        { id: 'creditnotes', label: 'Avoirs', visible: true, sortable: false },
        { id: 'title', label: 'Intitulé', visible: false, sortable: true },
        { id: 'stored.client.insensitive', label: 'Client', visible: true, sortable: true },
        { id: 'delivery', label: 'Zone de livraison', visible: true, sortable: false },
        { id: 'date', label: 'Émission', visible: true, sortable: true },
        { id: 'dueDate', label: 'Échéance', visible: true, sortable: true },
        { id: 'status', label: 'État', visible: true, sortable: true },
        { id: 'tags', label: 'Mots-clés', visible: true, sortable: false },
        { id: 'referers', label: 'Référents', visible: true, sortable: false },
        { id: 'computed.fullDiscountedTotal', label: 'Total HT', visible: false, sortable: true },
        { id: 'computed.discount', label: 'Remise', visible: false, sortable: true },
        { id: 'totalVAT', label: 'TVA', visible: false, sortable: true },
        { id: 'balanceDue', label: 'Balance', visible: true, sortable: true },
        { id: 'balancePaid', label: 'Perçu', visible: false, sortable: false },
        { id: 'fullTotal', label: 'TTC', visible: true, sortable: false },
        { id: 'bpu', label: 'BPU', visible: true, sortable: false },
        { id: 'interventionsCount', label: 'Interventions liées', visible: true, sortable: false },
        { id: 'type', label: 'Acompte', visible: true, sortable: true },
        { id: 'clientNumber', label: 'Numéro client', visible: true, sortable: false },
        { id: 'paymentsType', label: 'Type de Paiement', visible: true, sortable: false },
        { id: 'createdAt', label: 'Date de création', visible: true, sortable: true },
        // Pennylane : en dur (dispo pour TOUS les clients, pas de gating AppAccessService — ≠ Chorus).
        // Factures uniquement : les avoirs sont hors périmètre Pennylane.
        { id: 'sentToPennylane', label: 'Envoyée sur Pennylane', visible: false, sortable: false }
      ],
      order: [
        { id: 'number', label: 'Numéro', visible: true, sortable: true },
        { id: 'reference', label: 'Référence client', visible: true, sortable: true },
        { id: 'title', label: 'Intitulé', visible: false, sortable: true },
        { id: 'client', label: 'Client', visible: true, sortable: true },
        { id: 'date', label: 'Émission', visible: true, sortable: true },
        { id: 'dueDate', label: 'Échéance', visible: true, sortable: true },
        { id: 'status', label: 'État', visible: true, sortable: true },
        { id: 'tags', label: 'Mots-clés', visible: true, sortable: false },
        { id: 'referers', label: 'Référents', visible: true, sortable: false },
        { id: 'total', label: 'Total HT', visible: false, sortable: true },
        { id: 'discountedTotal', label: 'Total Remisé', visible: false, sortable: false },
        { id: 'totalVAT', label: 'TVA', visible: false, sortable: true },
        { id: 'balanceDue', label: 'Balance', visible: true, sortable: true },
        { id: 'balancePaid', label: 'Perçu', visible: false, sortable: false },
        { id: 'fullTotal', label: 'Marché TTC', visible: true, sortable: false },
        { id: 'bpu', label: 'BPU', visible: true, sortable: false },
        { id: 'progress', label: 'Avancement', visible: true, sortable: false },
        { id: 'totalBilled', label: 'Facturé TTC', visible: true, sortable: false }
      ],
      quote: [
        { id: 'number', label: 'Numéro', visible: true, sortable: true },
        { id: 'reference', label: 'Référence client', visible: true, sortable: true },
        { id: 'title', label: 'Intitulé', visible: false, sortable: true },
        { id: 'stored.client.insensitive', label: 'Client', visible: true, sortable: true },
        { id: 'delivery', label: 'Zone de livraison', visible: true, sortable: false },
        { id: 'date', label: 'Émission', visible: true, sortable: true },
        { id: 'dueDate', label: 'Échéance', visible: true, sortable: true },
        { id: 'signDate', label: 'Signature', visible: true, sortable: true },
        { id: 'status', label: 'État', visible: true, sortable: true },
        { id: 'tags', label: 'Mots-clés', visible: true, sortable: false },
        { id: 'referers', label: 'Référents', visible: true, sortable: false },
        { id: 'computed.fullDiscountedTotal', label: 'Total HT', visible: true, sortable: true },
        { id: 'computed.discount', label: 'Remise', visible: false, sortable: true },
        { id: 'fullTotal', label: 'Total TTC', visible: true, sortable: true },
        { id: 'totalVAT', label: 'TVA', visible: false, sortable: true },
        { id: 'bpu', label: 'BPU', visible: true, sortable: false },
        { id: 'interventionsCount', label: 'Interventions liées', visible: true, sortable: false },
        { id: 'invoiceDeposit', label: 'Acompte', visible: true, sortable: true },
        { id: 'createdAt', label: 'Date de création', visible: true, sortable: true }
      ],
      creditnote: [
        { id: 'number', label: 'Numéro', visible: true, sortable: true },
        { id: 'reference', label: 'Référence client', visible: true, sortable: true },
        { id: 'title', label: 'Intitulé', visible: false, sortable: true },
        { id: 'stored.client.insensitive', label: 'Client', visible: true, sortable: true },
        { id: 'date', label: 'Émission', visible: true, sortable: true },
        { id: 'dueDate', label: 'Échéance', visible: true, sortable: true },
        { id: 'status', label: 'État', visible: true, sortable: true },
        { id: 'tags', label: 'Mots-clés', visible: true, sortable: false },
        { id: 'referers', label: 'Référents', visible: true, sortable: false },
        { id: 'total', label: 'Total HT', visible: false, sortable: true },
        { id: 'totalVAT', label: 'TVA', visible: false, sortable: true },
        { id: 'balanceDue', label: 'Balance', visible: true, sortable: true },
        { id: 'balancePaid', label: 'Perçu', visible: false, sortable: false },
        { id: 'fullTotal', label: 'TTC', visible: true, sortable: false },
        { id: 'createdAt', label: 'Date de création', visible: true, sortable: true }
      ],
      product: [
        { id: 'reference', label: 'Référence', visible: true, sortable: true },
        { id: 'label', label: 'Désignation', visible: true, sortable: true },
        { id: 'category', label: 'Catégorie', visible: true, sortable: true },
        { id: 'tags', label: 'Mots-clés', visible: true, sortable: false },
        { id: 'price', label: 'Prix', visible: true, sortable: true },
        { id: 'unit', label: 'Unité', visible: false, sortable: true },
        { id: 'VAT', label: 'TVA', visible: true, sortable: true },
        { id: 'bpu', label: 'BPU', visible: true, sortable: false },
        { id: 'type', label: 'Type', visible: true, sortable: false }
      ],
      entity: [
        { id: 'insensitive', label: 'Nom', visible: true, sortable: true },
        { id: 'number', label: 'N° client', visible: true, sortable: true },
        { id: 'account', label: 'Compte client', visible: true, sortable: true },
        { id: 'siret', label: 'Siret', visible: true, sortable: false },
        { id: 'defaultAddress', label: 'Adresse', visible: true, sortable: true },
        { id: 'balance', label: 'Balance', visible: true, sortable: false },
        { id: 'invoices', label: 'Factures', visible: true, sortable: false },
        { id: 'quotes', label: 'Devis', visible: true, sortable: false },
        { id: 'creditnotes', label: 'Avoirs', visible: true, sortable: false }
      ],
      subcontractor: [
        { id: 'insensitive', label: 'Nom', visible: true, sortable: true },
        { id: 'defaultAddress', label: 'Adresse', visible: true, sortable: true }
      ],
      inmail: [
        { id: 'raw.title', label: 'Titre', visible: true, sortable: true },
        { id: 'metadata.receivedAt', label: 'Date de réception', visible: true, sortable: true }
      ],
      bpu: [
        { id: 'label', label: 'Nom', visible: true, sortable: true },
        { id: 'client', label: 'Client', visible: true, sortable: true },
        { id: 'start', label: 'Date de début', visible: true, sortable: true },
        { id: 'end', label: 'Date de fin', visible: true, sortable: true }
      ],
      payment: [
        { id: 'number', label: 'Numéro', visible: true, sortable: true },
        { id: 'title', label: 'Intitulé', visible: false, sortable: true },
        // { id: 'client', label: 'Client', visible: true, sortable: true },
        { id: 'date', label: 'Émission', visible: true, sortable: true },
        { id: 'dueDate', label: 'Échéance', visible: true, sortable: true },
        { id: 'payments.date', label: 'Date du paiement', visible: true, sortable: true },
        { id: 'payments.amount.amount', label: 'Montant', visible: true, sortable: true },
        { id: 'payments.type', label: 'Méthode', visible: true, sortable: true },
        { id: 'payments.transactionId', label: 'Référence', visible: true, sortable: true }
      ],
      categories: [
        { id: 'label', label: 'Nom', visible: true, sortable: true }
      ]
    }
    const chorusColumns = [
      { id: 'integratedOnChorus', label: 'Intégrée sur CHORUS', visible: false, sortable: false },
      { id: 'statutCourantChorus', label: 'Statut courant CHORUS', visible: false, sortable: false }
    ]

    init()

    function init () {
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs
        loadNewColumns()
        if (!self.rightsReached) {
          self.rightsReached = true
          AppAccessService.getCompanyRights().then((rights) => {
            rights.forEach((right) => {
              if (right.appName === 'CHORUS' && right.hasAccess) {
                defaultColumns.invoice.push(...chorusColumns)
                defaultColumns.creditnote.push(...chorusColumns)
              }
            })
          })
        }
      })
    }

    function buildColumns (cfs, cols) {
      var settings = cols
      var customFields = _.map(_.filter(cfs, function (elt) {
        return elt.type !== 'File'
      }), function (value) {
        return { id: value.key, label: value.label, visible: true, sortable: false }
      })
      var toAdd = _.differenceBy(customFields, settings, 'id')
      return _.union(settings, toAdd)
    }

    function loadNewColumns () {
      if (self.prefs && self.prefs.hasOwnProperty('settings')) {
        _.each(defaultColumns, function (value, key) {
          var listKey = key === 'inmail' ? 'inboxList' : key + 'List'
          if (!self.prefs.settings.hasOwnProperty(listKey)) {
            self.prefs.settings[listKey] = {
              columns: angular.copy(defaultColumns[key]),
              pagination: 10
            }
          }

          if (!self.prefs.settings[listKey].columns) {
            self.prefs.settings[listKey].columns = angular.copy(defaultColumns[key])
          }
          var defaultIdMap = _.map(defaultColumns[key], 'id')
          var prefsIdMap = _.map(self.prefs.settings[listKey].columns, 'id')
          var diff = _.difference(defaultIdMap, prefsIdMap)
          if (diff.length) {
            _.each(diff, function (elt) {
              var index = _.indexOf(defaultIdMap, elt)
              self.prefs.settings[listKey].columns.splice(index, 0, defaultColumns[key][index])
              self.prefs.save().then(function () {})
            })
          }
          /* Removed to fix an issue with the cutsom fields not beign saved on refresh
          var removed = _.difference(prefsIdMap, defaultIdMap)
          if (removed.length) {
            _.each(removed, function (elt) {
              _.remove(self.prefs.settings[listKey].columns, function (c) {
                return c.id === elt
              })
              self.prefs.save().then(function () {})
            })
          }
          */
          var defaultLabelMap = _.map(defaultColumns[key], 'label')
          var labelDiff = _.difference(defaultLabelMap, _.map(self.prefs.settings[listKey].columns, 'label'))
          if (labelDiff.length) {
            _.each(labelDiff, function (elt) {
              var index = _.indexOf(defaultLabelMap, elt)
              self.prefs.settings[listKey].columns[index].label = elt
              self.prefs.save().then(function () {})
            })
          }
        })
      }
    }

    function getDefaultColumns (type) {
      return angular.copy(defaultColumns[type])
    }

    function getColumns (type) {
      if (!self.prefs || !self.prefs.hasOwnProperty('settings')) {
        return angular.copy(defaultColumns[type])
      }
      switch (type) {
        case 'invoice':
          if (self.prefs.settings.invoiceList.columns) {
            return self.prefs.settings.invoiceList.columns
          }
          return angular.copy(defaultColumns[type])
        case 'quote':
          if (self.prefs.settings.quoteList.columns) {
            return self.prefs.settings.quoteList.columns
          }
          return angular.copy(defaultColumns[type])
        case 'order':
          if (self.prefs.settings.orderList.columns) {
            return self.prefs.settings.orderList.columns
          }
          return angular.copy(defaultColumns[type])
        case 'creditnote':
          if (self.prefs.settings.creditnoteList.columns) {
            return self.prefs.settings.creditnoteList.columns
          }
          return angular.copy(defaultColumns[type])
        case 'product':
          if (self.prefs.settings.productList.columns) {
            return self.prefs.settings.productList.columns
          }
          return angular.copy(defaultColumns[type])
        case 'entity':
          if (self.prefs.settings.entityList.columns) {
            return self.prefs.settings.entityList.columns
          }
          return angular.copy(defaultColumns[type])
        case 'inmail':
          if (self.prefs.settings.inboxList.columns) {
            return self.prefs.settings.inboxList.columns
          }
          return angular.copy(defaultColumns[type])
        case 'bpu':
          if (self.prefs.settings.bpuList.columns) {
            return self.prefs.settings.bpuList.columns
          }
          return angular.copy(defaultColumns[type])
        case 'payment':
          return angular.copy(defaultColumns[type])
        case 'categories':
          if (self.prefs.settings.categoriesList.columns) {
            return self.prefs.settings.categoriesList.columns
          }
          return angular.copy(defaultColumns[type])
        default:
          console.warn(`Unhandled model for column ${type}`)
          return angular.copy(defaultColumns[type])
      }
    }
  }
})(window.angular, window._)
